import { render, staticRenderFns } from "./myClassCourseDialog.vue?vue&type=template&id=10e050d0"
import script from "./myClassCourseDialog.vue?vue&type=script&lang=js"
export * from "./myClassCourseDialog.vue?vue&type=script&lang=js"
import style0 from "./myClassCourseDialog.vue?vue&type=style&index=0&id=10e050d0&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports